import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { LanguageUtils } from '../../utils/language.utils';
import { environment } from '../../../../environments/environment';
import { Captcha, Contact, IContactsService, ContactRequest, ContactResponse, FiltersContact, ContactsResponse } from './contacts.interface';
import { Attachment } from '../attachments/attachments.interface';

@Injectable({
  providedIn: 'root'
})
export class ContactsService implements IContactsService {
  constructor(
    private httpClient: HttpClient
  ) { }
  // public 8002
  getCaptcha(): Observable<Captcha> {
    // GET https://{{server}}:8002/zbe/exceptions/captcha?language=es-ES
    return this.httpClient.get<Captcha>(environment.apiPublicUrl + '/captcha?language=' + LanguageUtils.getLanguage());
  }
  createContact(newContact: ContactRequest): Observable<any> {
    // POST, https://{{server}}:8002/zbe/exceptions/contact?language=es-ES
    return this.httpClient.post<any>(environment.apiPublicUrl + '/contact?language=' + LanguageUtils.getLanguage(), newContact);
  }

  // private 8003
  buildUrl(filters: FiltersContact, order: string): string {
    // https://{{server}}:8003/zbe/exceptions/contacts?states=Pending,Revision,Closed&types=Complaint,Suggestion,Information,Other&name=Andrés&email=andres.diez&subject=Consulta&record=&municipalities=Terrassa&from=2024-01-01T00:00:00&to=2025-12-01T00:00:00&language=ca-ES
    let url = environment.apiPrivateUrl + '/contacts?language=' + LanguageUtils.getLanguage();
    if (filters.identifier) {
      url += '&identifier=' + filters.identifier;
    }
    if (filters.states) {
      url += '&state=' + filters.states;
    }
    if (filters.types) {
      url += '&type=' + filters.types;
    }
    if (filters.name) {
      url += '&name=' + filters.name;
    }
    if (filters.email) {
      url += '&email=' + filters.email;
    }
    if (filters.subject) {
      url += '&subject=' + filters.subject;
    }
    if (filters.record) {
      url += '&record=' + filters.record;
    }
    if (filters.municipalities) {
      url += '&municipality=' + filters.municipalities;
    }
    if (filters.description) {
      url += '&description=' + filters.description;
    }
    if (filters.operators) {
      url += '&operators=' + filters.operators;
    }
    if (filters.from) {
      // "2025-02-12" sent as 2024-01-01T00:00:00
      url += '&from=' + new Date(filters.from).toISOString();
    }
    if (filters.to) {
      url += '&to=' + new Date(filters.to).toISOString();
    }
    if (filters.dateUnique) {
      // use dateUnique instead of from as T00:00:00 and to as T23:59:59
      var from = new Date(filters.dateUnique);
      from.setHours(0, 0, 0, 0);
      var to = new Date(filters.dateUnique);
      to.setHours(23, 59, 59, 999);
      url += '&from=' + from.toISOString();
      url += '&to=' + to.toISOString();
    }
    if (filters.limit) {
      url += '&limit=' + filters.limit;
    }
    if (filters.offset) {
      url += '&offset=' + filters.offset;
    }
    if (order && order !== ' ') {
      url += '&order=' + order;
    }
    if (filters.exportToExcel) {
      // delete limit and offset
      url = url.replace('&limit=' + filters.limit, '');
      url = url.replace('&offset=' + filters.offset, '');
      url += '&format=application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    }
    return url;
  }
  getContacts(filters: FiltersContact, order: string): Observable<ContactsResponse> {
    return this.httpClient.get<ContactsResponse>(this.buildUrl(filters, order));
  }
  getContact(id: string): Observable<Contact> {
    // GET https://{{server}}:8003/zbe/exceptions/contact?contact=2&language=ca-ES
    return this.httpClient.get<Contact>(environment.apiPrivateUrl + '/contact?contact=' + id + '&language=' + LanguageUtils.getLanguage());
  }
  getContactFile(id: string): Observable<Attachment> {
    // GET https://{{server}}:8003/zbe/exceptions/contact/attachment?contact=2&attachment=463c1e93-da2b-4ac5-b886-19d4b3dccabc&language=ca-ES
    return this.httpClient.get<Attachment>(environment.apiPrivateUrl + '/contact/attachment?contact=' + id + '&language=' + LanguageUtils.getLanguage());
  }
  deleteContactFile(contactId: string, fileId: string): Observable<string> {
    // DELETE https://{{server}}:8003/zbe/exceptions/contact/attachment?contact=2&attachment=463c1e93-da2b-4ac5-b886-19d4b3dccabc&language=ca-ES
    return this.httpClient.delete<string>(environment.apiPrivateUrl + '/contact/attachment?contact=' + contactId + '&attachment=' + fileId + '&language=' + LanguageUtils.getLanguage());
  }
  assignOperatorToContact(id: string, operator: string): Observable<Contact> {
    // POST https://{{server}}:8003/zbe/exceptions/contact/assign?contact=2&operator=44176936P&language=ca-ES
    return this.httpClient.post<Contact>(environment.apiPrivateUrl + '/contact/assign?contact=' + id + '&operator=' + operator + '&language=' + LanguageUtils.getLanguage(), {});
  }
  addCommentToContact(id: string, state: string, comment: ContactResponse): Observable<Contact> {
    // POST https://{{server}}:8003/zbe/exceptions/contact?contact=2&state=Revision&language=ca-ES
    return this.httpClient.post<Contact>(environment.apiPrivateUrl + '/contact?contact=' + id + '&state=' + state + '&language=' + LanguageUtils.getLanguage(), comment);
  }
  updateContact(id: string, contact: Contact): Observable<Contact> {
    // PUT https://{{server}}:8003/zbe/exceptions/contact?contact=2&language=ca-ES
    return this.httpClient.put<Contact>(environment.apiPrivateUrl + '/contact?contact=' + id + '&language=' + LanguageUtils.getLanguage(), contact);
  }
}
